import React from 'react';
import { BrowserRouter as Router, Routes, Route, useParams } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import MainContent from './components/MainContent';
import HomePage from './pages/HomePage';
import ProductsPage from './pages/ProductsPage';
import ContactPage from './pages/ContactPage';
import NewsPage from './pages/NewsPage';
import AboutPage from './pages/AboutPage';
import NotFoundPage from './pages/NotFoundPage';
import ProductDetailPage from './pages/ProductDetailPage';
import NewsDetailPage from './pages/NewsDetailPage';

import 'bootstrap/dist/css/bootstrap.min.css';
import './css/style.css';

// Import your product and news data
import productData from './data/productData';
import newsArticles from './data/newsArticles';

// Function to find a product by its slug
const findProductBySlug = (slug) => {
    return productData.find(product => product.detailsLink.split('/').pop() === slug);
};

// Function to find a news article by its slug
const findNewsArticleBySlug = (slug) => {
    return newsArticles.find(article => article.detailsLink.split('/').pop() === slug);
};

const ProductDetailPageWrapper = () => {
    const { slug } = useParams();
    const product = findProductBySlug(slug);

    if (!product) {
        return <NotFoundPage />;
    }

    return <ProductDetailPage product={product} />;
};

const NewsDetailPageWrapper = () => {
    const { slug } = useParams();
    const news = findNewsArticleBySlug(slug);

    if (!news) {
        return <NotFoundPage />;
    }

    return <NewsDetailPage news={news} />; // Pass the found news article as the 'news' prop
};

const App = () => {
    return (
        <Router>
            <div className="d-flex flex-column min-vh-100">
                <Header />
                <div className="flex-grow-1">
                    <MainContent>
                        <Routes>
                            <Route path="/" element={<HomePage />} />
                            <Route path="/products" element={<ProductsPage />} />
                            <Route path="/products/:slug" element={<ProductDetailPageWrapper />} />
                            <Route path="/contact" element={<ContactPage />} />
                            <Route path="/news" element={<NewsPage />} />
                            <Route path="/news/:slug" element={<NewsDetailPageWrapper />} />
                            <Route path="/about" element={<AboutPage />} />
                            <Route path="*" element={<NotFoundPage />} />
                        </Routes>
                    </MainContent>
                </div>
                <Footer />
            </div>
        </Router>
    );
};

export default App;